"use client";
import React, { useEffect, useRef } from "react";

const DesktopSky = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    let ctx: CanvasRenderingContext2D | null = null;
    try {
      ctx = canvas.getContext("2d");
    } catch {
      return;
    }
    if (!ctx) return;

    const W = 1920;
    const H = 1080;
    canvas.width = W;
    canvas.height = H;

    const reduced =
      typeof matchMedia !== "undefined" &&
      matchMedia("(prefers-reduced-motion: reduce)").matches;

    const stars = Array.from({ length: 230 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1.4 + 0.3,
      p: Math.random() * Math.PI * 2,
      s: 0.4 + Math.random() * 1.2,
      big: Math.random() > 0.94,
    }));

    let raf = 0;
    const draw = (t: number) => {
      ctx!.clearRect(0, 0, W, H);
      for (const st of stars) {
        const a = reduced
          ? 0.7
          : 0.35 + 0.55 * Math.abs(Math.sin((t / 1400) * st.s + st.p));
        ctx!.globalAlpha = a;
        ctx!.fillStyle = st.big ? "#cfe3ff" : "#e7defc";
        ctx!.beginPath();
        ctx!.arc(st.x, st.y, st.r, 0, 7);
        ctx!.fill();
        if (st.big) {
          ctx!.globalAlpha = a * 0.28;
          ctx!.beginPath();
          ctx!.arc(st.x, st.y, st.r * 3.4, 0, 7);
          ctx!.fill();
        }
      }
      if (!reduced) raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <>
      <div
        aria-hidden
        className="absolute inset-0 -z-3"
        style={{
          background: [
            "radial-gradient(1100px 620px at 82% -10%, rgba(107,70,214,.34), transparent 62%)",
            "radial-gradient(900px 560px at -6% 16%, rgba(75,91,215,.26), transparent 60%)",
            "radial-gradient(760px 500px at 50% 118%, rgba(224,95,190,.16), transparent 62%)",
            "linear-gradient(180deg,#120e2c 0%,#0a081d 46%,#070514 100%)",
          ].join(","),
        }}
      />
      <canvas
        ref={canvasRef}
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-2 h-full w-full"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-1"
        style={{
          background:
            "radial-gradient(120% 90% at 50% 40%, transparent 55%, rgba(4,2,14,.55) 100%)",
        }}
      />
    </>
  );
};

export default DesktopSky;
